import React, { useEffect } from "react";
import { EnumRadioFieldValue } from "../../types/fieldTypes";
import { EnumRadioFieldProps } from "./EnumRadioField";

export const useEnumRadioField = (props: EnumRadioFieldProps) => {
  const [localValue, setLocalValue] = React.useState<EnumRadioFieldValue>(
    props.value
  );

  useEffect(() => {
    setLocalValue(props.value);
  }, [props.value]);

  return { localValue, setLocalValue };
};
